import { CommonModule } from '@angular/common';

import { ChangeDetectionStrategy,Component,EventEmitter,Input,Output } from '@angular/core';
import { FormControl,FormsModule } from '@angular/forms';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';

@Component({
    selector: 'app-expandable-searchbar',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule, MatLegacyButtonModule, MatLegacyFormFieldModule, MatLegacyInputModule, AppButtonModule, MatLegacyTooltipModule, FormsModule],
    templateUrl: './expandable-searchbar.component.html',
    styleUrls: ['./expandable-searchbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableSearchbarComponent {
    @Input() expanded = false;
    @Output() expandedChange = new EventEmitter<boolean>();
    @Input() placeholder = 'suchen...';
    @Input() searchQuery = '';
    @Output() searchQueryChange = new EventEmitter<string>();
    public searchForm = new FormControl<string>('');

    toggleExpanded() {
        this.expanded = !this.expanded;
        this.expandedChange.emit(this.expanded);
    }
    resetSearch() {
        this.searchQuery = '';
        this.searchQueryChange.emit(this.searchQuery);
    }
}
